import { render, staticRenderFns } from "./xskPopup.vue?vue&type=template&id=c33d573e&scoped=true"
import script from "./xskPopup.vue?vue&type=script&lang=js"
export * from "./xskPopup.vue?vue&type=script&lang=js"
import style0 from "./xskPopup.vue?vue&type=style&index=0&id=c33d573e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33d573e",
  null
  
)

export default component.exports